//@TODO - kil me when we kill phantomjs;
import $ from 'jquery';
/**
 * @description Gets initData from HTML string or body tag;
 * @class InitData
 */
class InitData {
    constructor() {
        this.currentData = null;
    }

    /**
     * @returns {object} current initData
     * @memberof InitData
     */
    current() {
        return this.currentData ? { ...this.currentData } : null;
    }

    getForScribe() {
        let currentClone = this.current();
        if (currentClone) {
            delete currentClone.description;
            delete currentClone.viewHtml;
        }
        return currentClone;
    }

    /**
     * @param {(string|Array)} html HTML string or dom Nodes Array.
     * @returns  {object} JSON representation of initData innerHTML
     * @memberof InitData
     */
    parseHtml(html) {
        //@TODO - when we kill phantom use the following 2 lines
        // let doc = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
        // let initDataString = doc.querySelectorAll('#init-data')[0].innerHTML;
        let initDataString = $(html)
            .find('#init-data')
            .html();
        return initDataString ? JSON.parse(initDataString) : null;
    }

    setFromHtml(html) {
        let parsed = this.parseHtml(html);
        this.set(parsed);
        return this.current();
    }

    set(val) {
        this.currentData = val;
    }

    currentOrSet() {
        let c = this.current();
        if (c !== null) {
            return c;
        }
        return this.setFromHtml(document.body);
    }
}

export default new InitData();
